var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"non-bind-mask"},[_c('div',{staticClass:"mask-content"},[_c('img',{attrs:{"src":require("@/assets/qualificationQuery/vip_icon.png"),"alt":""}}),_c('p',[_vm._v("您尚未绑定企业，请先绑定企业后查看")]),_c('router-link',{attrs:{"to":"/user/common/company"}},[_vm._v("\n\t\t\t立即绑定\n\t\t\t"),_c('i',{staticClass:"el-icon-arrow-right"})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }